import { render } from "./EditHospital.vue?vue&type=template&id=81a3272c"
import script from "./EditHospital.vue?vue&type=script&lang=js"
export * from "./EditHospital.vue?vue&type=script&lang=js"

import "./EditHospital.vue?vue&type=style&index=0&id=81a3272c&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/hospitals/EditHospital.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "81a3272c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('81a3272c', __exports__)) {
    console.log('reload')
    api.reload('81a3272c', __exports__)
  }
  
  module.hot.accept("./EditHospital.vue?vue&type=template&id=81a3272c", () => {
    console.log('re-render')
    api.rerender('81a3272c', render)
  })

}


export default __exports__